import React from 'react'
import {
  ModalBody,
  ModalContent,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  Button,
  Box,
  useDisclosure,
} from '@chakra-ui/react'
import { useMemo } from 'react'
import * as T from '../../../components/Table'
import { formatPrice } from '../../../utils/formatPrice'

export const AReceber = ({ data = [] }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { totals } = useMemo(() => {
    const totals = data.reduce(
      (acc, pedido) => {
        const totalPagar = pedido.parcelas_pagar * pedido.valor_parcela_real

        if (pedido.pagamento === 'Cartão Credito') {
          acc.cartao.aPagar += totalPagar
          acc.cartao.quantidadeParcelas += pedido.parcelas_pagar
        } else if (pedido.pagamento === 'Boleto') {
          acc.boleto.aPagar += totalPagar
          acc.boleto.quantidadeParcelas += pedido.parcelas_pagar
        }

        return acc
      },
      {
        cartao: { aPagar: 0, quantidadeParcelas: 0 },
        boleto: { aPagar: 0, quantidadeParcelas: 0 },
      }
    )

    return { totals }
  }, [data])

  return (
    <Box>
      <Button onClick={onOpen}>A Receber</Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Sumário de valores a receber</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <T.Table>
              <T.Thead>
                <T.Th>Forma de pagamento</T.Th>
                <T.Th>Quantidade de parcelas</T.Th>
                <T.Th>Valor a receber</T.Th>
              </T.Thead>
              <T.Tbody>
                <T.Tr>
                  <T.Td>Cartão de Crédito</T.Td>
                  <T.Td>{totals.cartao.quantidadeParcelas}</T.Td>
                  <T.Td>{formatPrice(totals.cartao.aPagar)}</T.Td>
                </T.Tr>
                <T.Tr>
                  <T.Td>Boleto</T.Td>
                  <T.Td>{totals.boleto.quantidadeParcelas}</T.Td>
                  <T.Td>{formatPrice(totals.boleto.aPagar)}</T.Td>
                </T.Tr>
              </T.Tbody>
            </T.Table>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}
